import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OfferDetailsPageComponent } from './offer-details-page/offer-details-page.component';

const routes: Routes = [
  {
    path: '',
    component: OfferDetailsPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OfferDetailsPageRoutingModule { }
